module.exports = __webpack_public_path__ + "static/media/skills.f3eb9da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills.png
// module id = 205
// module chunks = 0